// extracted by mini-css-extract-plugin
export default {"create-account-button":"p5vOvgCt5KOMQNdddBxg"};